// import { ChevronLeft, ChevronRight, MoveRight } from "lucide-react";
// import { useState, useEffect } from "react";
// import { images } from "../../assets/assets";
// import { Link } from "react-router-dom";
// import { getImageUrl } from "../../utils/getImageUrl";
// import { getAllServices } from "../../api";

// // Skeleton Loading Component
// const ServiceSkeleton = () => (
//   <div className="flex-shrink-0 rounded-[12px] overflow-hidden animate-pulse bg-gray-300 h-[280px] sm:h-[320px] md:h-[364px]" />
// );

// const MedicalServices = () => {
//   const [medicalServices, setMedicalServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await getAllServices();
//         setMedicalServices(response?.data || response || []);
//       } catch (err) {
//         setError("Failed to load services. Please try again later.");
//         console.error("Error fetching services:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchServices();
//   }, []);

//   //   {
//   //     heading: "Medicine Department",
//   //     desc: "Our medicine department provides comprehensive care for a wide range of conditions with expert physicians.",
//   //     Img: images.ServiceOne,
//   //   },
//   //   {
//   //     heading: "Obstetrics and Gynaecology Department",
//   //     desc: "Our Obstetrics and Gynaecology department provides comprehensive maternal and women's health services.",
//   //     Img: images.ServiceTwo,
//   //   },
//   //   {
//   //     heading: "General Surgery Department",
//   //     desc: "Our General Surgery department offers advanced surgical care for a wide range of conditions.",
//   //     Img: images.ServiceThree,
//   //   },
//   //   {
//   //     heading: "Paediatrics Department",
//   //     desc: "Our Paediatrics department provides specialized healthcare for infants, children and adolescents.",
//   //     Img: images.ServiceFour,
//   //   },
//   //   {
//   //     heading: "Orthopaedics Department",
//   //     desc: "Advanced bone, joint and musculoskeletal care for injuries and chronic conditions.",
//   //     Img: images.ServiceOne,
//   //   },
//   //   {
//   //     heading: "Neurology Department",
//   //     desc: "Expert neurological care for brain, spine and nervous system disorders.",
//   //     Img: images.ServiceTwo,
//   //   },
//   // ];

//   const itemsPerViewXL = 4;
//   const itemsPerViewMD = 3;
//   const itemsPerViewTablet = 2;

//   const maxIndexXL = medicalServices.length - itemsPerViewXL;
//   const maxIndexMD = medicalServices.length - itemsPerViewMD;
//   const maxIndexTablet = medicalServices.length - itemsPerViewTablet;

//   const prev = () => setCurrentIndex((p) => Math.max(0, p - 1));
//   const nextXL = () => setCurrentIndex((p) => Math.min(maxIndexXL, p + 1));
//   const nextMD = () => setCurrentIndex((p) => Math.min(maxIndexMD, p + 1));
//   const nextTablet = () =>
//     setCurrentIndex((p) => Math.min(maxIndexTablet, p + 1));
//   const nextMobile = () =>
//     setCurrentIndex((p) => Math.min(medicalServices.length - 1, p + 1));

//   if (error) {
//     return (
//       <div className="bg-[#F7F7F7B2] py-10 md:py-12">
//         <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
//           Our Medical Services
//         </h3>
//         <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
//           Our medical services are designed to deliver complete, high-quality
//           healthcare through advanced technology, expert specialists, and a
//           patient-centered approach for every stage of treatment.
//         </p>
//         <div className="text-center py-12">
//           <p className="text-red-500 font-poppins font-semibold text-[16px] mb-4">
//             {error}
//           </p>
//           <button
//             onClick={() => window.location.reload()}
//             className="bg-[#1975FF] text-white px-6 py-2 rounded-[10px] hover:bg-[#1560d4] transition-all"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-[#F7F7F7B2] py-10 md:py-12">
//       <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
//         Our Medical Services
//       </h3>
//       <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
//         Our medical services are designed to deliver complete, high-quality
//         healthcare through advanced technology, expert specialists, and a
//         patient-centered approach for every stage of treatment.
//       </p>

//       {loading ? (
//         <>
//           {/* XL 4-column skeleton */}
//           <div className="hidden xl:block w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div className="flex gap-6">
//               {[...Array(4)].map((_, idx) => (
//                 <ServiceSkeleton key={idx} />
//               ))}
//             </div>
//           </div>

//           {/* MD to LG: 3-column skeleton */}
//           <div className="hidden md:block xl:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div className="flex gap-6">
//               {[...Array(3)].map((_, idx) => (
//                 <ServiceSkeleton key={idx} />
//               ))}
//             </div>
//           </div>

//           {/* SM to MD: 2-column skeleton */}
//           <div className="hidden sm:block md:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div className="flex gap-4">
//               {[...Array(2)].map((_, idx) => (
//                 <ServiceSkeleton key={idx} />
//               ))}
//             </div>
//           </div>

//           {/* Mobile: 1-column skeleton */}
//           <div className="sm:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <ServiceSkeleton />
//           </div>
//         </>
//       ) : medicalServices.length === 0 ? (
//         <div className="text-center py-12 mt-8 md:mt-12">
//           <p className="font-poppins text-[16px] text-gray-600">
//             No service available
//           </p>
//         </div>
//       ) : (
//         <>
//           {/* XL 4-column carousel */}
//           <div className="hidden xl:block w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div
//               className="flex gap-6 transition-transform duration-400 ease-in-out"
//               style={{
//                 transform: `translateX(calc(-${currentIndex} * (25% + 6px)))`,
//               }}
//             >
//               {medicalServices.map((service, idx) => (
//                 <Link
//                   to={`service-detail/${service?.slug}`}
//                   key={idx}
//                   className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
//                   style={{ width: "calc(25% - 18px)" }}
//                 >
//                   <div
//                     className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
//                     style={{
//                       backgroundImage: `
//                       linear-gradient(
//                         180deg,
//                         rgba(102, 102, 102, 0) 40.87%,
//                         rgba(23, 23, 23, 0.545192) 69.71%,
//                         rgba(14, 14, 14, 0.56) 73.56%,
//                         rgba(0, 0, 0, 0.63) 88.94%
//                       ),
//                       url(${getImageUrl(service.imagePath)})
//                     `,
//                     }}
//                   >
//                     <div className="p-3 px-4 w-full">
//                       <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
//                         {service.name}
//                       </h4>
//                       <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
//                         <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
//                           <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
//                             {service.shortDesc}
//                           </p>
//                           <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
//                             <MoveRight
//                               color="#ffffff"
//                               className="rotate-[-38deg] w-4 h-4"
//                             />
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* MD to LG: 3-column carousel (768px - 1279px) */}
//           <div className="hidden md:block xl:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div
//               className="flex gap-6 transition-transform duration-400 ease-in-out"
//               style={{
//                 transform: `translateX(calc(-${currentIndex} * (calc(100% / 3) + 24px / 3)))`,
//               }}
//             >
//               {medicalServices.map((service, idx) => (
//                 <Link
//                   to={`service-detail/${service?.slug}`}
//                   key={idx}
//                   className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
//                   style={{ width: "calc(33.333% - 16px)" }}
//                 >
//                   <div
//                     className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
//                     style={{
//                       backgroundImage: `
//                       linear-gradient(
//                         180deg,
//                         rgba(102, 102, 102, 0) 40.87%,
//                         rgba(23, 23, 23, 0.545192) 69.71%,
//                         rgba(14, 14, 14, 0.56) 73.56%,
//                         rgba(0, 0, 0, 0.63) 88.94%
//                       ),
//                       url(${getImageUrl(service.imagePath)})
//                     `,
//                     }}
//                   >
//                     <div className="p-3 px-4 w-full">
//                       <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
//                         {service.name}
//                       </h4>
//                       <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
//                         <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
//                           <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
//                             {service.shortDesc}
//                           </p>
//                           <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
//                             <MoveRight
//                               color="#ffffff"
//                               className="rotate-[-38deg] w-4 h-4"
//                             />
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* SM to MD: 2-column carousel (640px - 767px) */}
//           <div className="hidden sm:block md:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div
//               className="flex gap-4 transition-transform duration-400 ease-in-out"
//               style={{
//                 transform: `translateX(calc(-${currentIndex} * (50% + 8px)))`,
//               }}
//             >
//               {medicalServices.map((service, idx) => (
//                 <Link
//                   to={`service-detail/${service?.slug}`}
//                   key={idx}
//                   className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
//                   style={{ width: "calc(50% - 8px)" }}
//                 >
//                   <div
//                     className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
//                     style={{
//                       backgroundImage: `
//                       linear-gradient(
//                         180deg,
//                         rgba(102, 102, 102, 0) 40.87%,
//                         rgba(23, 23, 23, 0.545192) 69.71%,
//                         rgba(14, 14, 14, 0.56) 73.56%,
//                         rgba(0, 0, 0, 0.63) 88.94%
//                       ),
//                       url(${getImageUrl(service.imagePath)})
//                     `,
//                     }}
//                   >
//                     <div className="p-3 px-4 w-full">
//                       <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
//                         {service.name}
//                       </h4>
//                       <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
//                         <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
//                           <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
//                             {service.shortDesc}
//                           </p>
//                           <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
//                             <MoveRight
//                               color="#ffffff"
//                               className="rotate-[-38deg] w-4 h-4"
//                             />
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* Mobile: 1-column carousel (<640px) */}
//           <div className="sm:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
//             <div
//               className="flex gap-4 transition-transform duration-400 ease-in-out"
//               style={{
//                 transform: `translateX(calc(-${currentIndex} * 100% - ${currentIndex * 16}px))`,
//               }}
//             >
//               {medicalServices.map((service, idx) => (
//                 <Link
//                   to={`service-detail/${service?.slug}`}
//                   key={idx}
//                   className="flex-shrink-0 w-full rounded-[12px] overflow-hidden shadow-md group cursor-pointer"
//                 >
//                   <div
//                     className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
//                     style={{
//                       backgroundImage: `
//                       linear-gradient(
//                         180deg,
//                         rgba(102, 102, 102, 0) 40.87%,
//                         rgba(23, 23, 23, 0.545192) 69.71%,
//                         rgba(14, 14, 14, 0.56) 73.56%,
//                         rgba(0, 0, 0, 0.63) 88.94%
//                       ),
//                       url(${getImageUrl(service.imagePath)})
//                     `,
//                     }}
//                   >
//                     <div className="p-3 px-4 w-full">
//                       <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
//                         {service.name}
//                       </h4>
//                       {/* Hover reveal desc */}
//                       <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
//                         <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
//                           <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
//                             {service.shortDesc}
//                           </p>
//                           <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
//                             <MoveRight
//                               color="#ffffff"
//                               className="rotate-[-38deg] w-4 h-4"
//                             />
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div>
//         </>
//       )}

//       {/* Controls */}
//       <div className="w-[90%] mx-auto my-5 flex items-center justify-between">
//         <button
//           onClick={prev}
//           disabled={currentIndex === 0}
//           className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 ease-in disabled:opacity-30 disabled:cursor-not-allowed"
//         >
//           <ChevronLeft className="w-5 h-5" />
//         </button>

//         {/* Dots */}
//         <div className="flex gap-2">
//           {/* XL Screen: max 4 indicators (for 4 visible items) */}
//           {Array.from({ length: maxIndexXL + 1 }).map((_, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentIndex(idx)}
//               className={`hidden xl:block w-2 h-2 rounded-full transition-all duration-200 ${
//                 idx === currentIndex
//                   ? "bg-[#1975FF] w-5"
//                   : "bg-gray-300 hover:bg-gray-400"
//               }`}
//             />
//           ))}

//           {/* MD to LG Screen: max 3 indicators */}
//           {Array.from({ length: maxIndexMD + 1 }).map((_, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentIndex(idx)}
//               className={`hidden md:block xl:hidden w-2 h-2 rounded-full transition-all duration-200 ${
//                 idx === currentIndex
//                   ? "bg-[#1975FF] w-5"
//                   : "bg-gray-300 hover:bg-gray-400"
//               }`}
//             />
//           ))}

//           {/* SM to MD Screen: max 2 indicators */}
//           {Array.from({ length: maxIndexTablet + 1 }).map((_, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentIndex(idx)}
//               className={`hidden sm:block md:hidden w-2 h-2 rounded-full transition-all duration-200 ${
//                 idx === currentIndex
//                   ? "bg-[#1975FF] w-5"
//                   : "bg-gray-300 hover:bg-gray-400"
//               }`}
//             />
//           ))}

//           {/* Mobile: all indicators */}
//           {medicalServices.map((_, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentIndex(idx)}
//               className={`sm:hidden w-2 h-2 rounded-full transition-all duration-200 ${
//                 idx === currentIndex
//                   ? "bg-[#1975FF] w-5"
//                   : "bg-gray-300 hover:bg-gray-400"
//               }`}
//             />
//           ))}
//         </div>

//         <button
//           onClick={() => {
//             // Determine next function based on screen size
//             if (window.innerWidth >= 1280) {
//               nextXL();
//             } else if (window.innerWidth >= 768) {
//               nextMD();
//             } else if (window.innerWidth >= 640) {
//               nextTablet();
//             } else {
//               nextMobile();
//             }
//           }}
//           disabled={
//             window.innerWidth >= 1280
//               ? currentIndex >= maxIndexXL
//               : window.innerWidth >= 768
//                 ? currentIndex >= maxIndexMD
//                 : window.innerWidth >= 640
//                   ? currentIndex >= maxIndexTablet
//                   : currentIndex >= medicalServices.length - 1
//           }
//           className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
//         >
//           <ChevronRight className="w-5 h-5" />
//         </button>
//       </div>

//       <Link
//         to="/services"
//         className="w-fit mx-auto -mt-2 bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
//       >
//         View Services{" "}
//         <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
//           <MoveRight color="#000" className="rotate-[-38deg] w-5 h-5" />
//         </span>
//       </Link>
//     </div>
//   );
// };

// export default MedicalServices;


import { ChevronLeft, ChevronRight, MoveRight } from "lucide-react";
import { useState, useEffect } from "react";
import { images } from "../../assets/assets";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../utils/getImageUrl";
import { getAllServices } from "../../api";

// Skeleton Loading Component
const ServiceSkeleton = () => (
  <div className="flex-shrink-0 rounded-[12px] overflow-hidden animate-pulse bg-gray-300 h-[280px] sm:h-[320px] md:h-[364px]" />
);

const MedicalServices = () => {
  const [medicalServices, setMedicalServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // SSR-safe: server par window exist nahi karta, isliye safe default (0) se start
  // aur mount hone ke baad hi real width set karte hain
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => setWindowWidth(window.innerWidth);
    updateWidth(); // initial value client par set karo
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAllServices();
        const srvArr = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.services)
          ? response.services
          : [];
        setMedicalServices(srvArr);
      } catch (err) {
        setError("Failed to load services. Please try again later.");
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const itemsPerViewXL = 4;
  const itemsPerViewMD = 3;
  const itemsPerViewTablet = 2;

  const maxIndexXL = medicalServices.length - itemsPerViewXL;
  const maxIndexMD = medicalServices.length - itemsPerViewMD;
  const maxIndexTablet = medicalServices.length - itemsPerViewTablet;

  const prev = () => setCurrentIndex((p) => Math.max(0, p - 1));
  const nextXL = () => setCurrentIndex((p) => Math.min(maxIndexXL, p + 1));
  const nextMD = () => setCurrentIndex((p) => Math.min(maxIndexMD, p + 1));
  const nextTablet = () =>
    setCurrentIndex((p) => Math.min(maxIndexTablet, p + 1));
  const nextMobile = () =>
    setCurrentIndex((p) => Math.min(medicalServices.length - 1, p + 1));

  if (error) {
    return (
      <div className="bg-[#F7F7F7B2] py-10 md:py-12">
        <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
          Our Medical Services
        </h3>
        <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
          Our medical services are designed to deliver complete, high-quality
          healthcare through advanced technology, expert specialists, and a
          patient-centered approach for every stage of treatment.
        </p>
        <div className="text-center py-12">
          <p className="text-red-500 font-poppins font-semibold text-[16px] mb-4">
            {error}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-[#1975FF] text-white px-6 py-2 rounded-[10px] hover:bg-[#1560d4] transition-all"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#F7F7F7B2] py-10 md:py-12">
      <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
        Our Medical Services
      </h3>
      <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
        Our medical services are designed to deliver complete, high-quality
        healthcare through advanced technology, expert specialists, and a
        patient-centered approach for every stage of treatment.
      </p>

      {loading ? (
        <>
          {/* XL 4-column skeleton */}
          <div className="hidden xl:block w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div className="flex gap-6">
              {[...Array(4)].map((_, idx) => (
                <ServiceSkeleton key={idx} />
              ))}
            </div>
          </div>

          {/* MD to LG: 3-column skeleton */}
          <div className="hidden md:block xl:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div className="flex gap-6">
              {[...Array(3)].map((_, idx) => (
                <ServiceSkeleton key={idx} />
              ))}
            </div>
          </div>

          {/* SM to MD: 2-column skeleton */}
          <div className="hidden sm:block md:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div className="flex gap-4">
              {[...Array(2)].map((_, idx) => (
                <ServiceSkeleton key={idx} />
              ))}
            </div>
          </div>

          {/* Mobile: 1-column skeleton */}
          <div className="sm:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <ServiceSkeleton />
          </div>
        </>
      ) : medicalServices.length === 0 ? (
        <div className="text-center py-12 mt-8 md:mt-12">
          <p className="font-poppins text-[16px] text-gray-600">
            No service available
          </p>
        </div>
      ) : (
        <>
          {/* XL 4-column carousel */}
          <div className="hidden xl:block w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div
              className="flex gap-6 transition-transform duration-400 ease-in-out"
              style={{
                transform: `translateX(calc(-${currentIndex} * (25% + 6px)))`,
              }}
            >
              {medicalServices.map((service, idx) => (
                <Link
                  to={`service-detail/${service?.slug}`}
                  key={idx}
                  className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
                  style={{ width: "calc(25% - 18px)" }}
                >
                  <div
                    className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
                    style={{
                      backgroundImage: `
                      linear-gradient(
                        180deg,
                        rgba(102, 102, 102, 0) 40.87%,
                        rgba(23, 23, 23, 0.545192) 69.71%,
                        rgba(14, 14, 14, 0.56) 73.56%,
                        rgba(0, 0, 0, 0.63) 88.94%
                      ),
                      url(${getImageUrl(service.imagePath)})
                    `,
                    }}
                  >
                    <div className="p-3 px-4 w-full">
                      <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
                        {service.name}
                      </h4>
                      <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
                        <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
                          <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
                            {service.shortDesc}
                          </p>
                          <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
                            <MoveRight
                              color="#ffffff"
                              className="rotate-[-38deg] w-4 h-4"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* MD to LG: 3-column carousel (768px - 1279px) */}
          <div className="hidden md:block xl:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div
              className="flex gap-6 transition-transform duration-400 ease-in-out"
              style={{
                transform: `translateX(calc(-${currentIndex} * (calc(100% / 3) + 24px / 3)))`,
              }}
            >
              {medicalServices.map((service, idx) => (
                <Link
                  to={`service-detail/${service?.slug}`}
                  key={idx}
                  className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
                  style={{ width: "calc(33.333% - 16px)" }}
                >
                  <div
                    className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
                    style={{
                      backgroundImage: `
                      linear-gradient(
                        180deg,
                        rgba(102, 102, 102, 0) 40.87%,
                        rgba(23, 23, 23, 0.545192) 69.71%,
                        rgba(14, 14, 14, 0.56) 73.56%,
                        rgba(0, 0, 0, 0.63) 88.94%
                      ),
                      url(${getImageUrl(service.imagePath)})
                    `,
                    }}
                  >
                    <div className="p-3 px-4 w-full">
                      <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
                        {service.name}
                      </h4>
                      <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
                        <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
                          <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
                            {service.shortDesc}
                          </p>
                          <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
                            <MoveRight
                              color="#ffffff"
                              className="rotate-[-38deg] w-4 h-4"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* SM to MD: 2-column carousel (640px - 767px) */}
          <div className="hidden sm:block md:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div
              className="flex gap-4 transition-transform duration-400 ease-in-out"
              style={{
                transform: `translateX(calc(-${currentIndex} * (50% + 8px)))`,
              }}
            >
              {medicalServices.map((service, idx) => (
                <Link
                  to={`service-detail/${service?.slug}`}
                  key={idx}
                  className="group relative flex-shrink-0 rounded-[12px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
                  style={{ width: "calc(50% - 8px)" }}
                >
                  <div
                    className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
                    style={{
                      backgroundImage: `
                      linear-gradient(
                        180deg,
                        rgba(102, 102, 102, 0) 40.87%,
                        rgba(23, 23, 23, 0.545192) 69.71%,
                        rgba(14, 14, 14, 0.56) 73.56%,
                        rgba(0, 0, 0, 0.63) 88.94%
                      ),
                      url(${getImageUrl(service.imagePath)})
                    `,
                    }}
                  >
                    <div className="p-3 px-4 w-full">
                      <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
                        {service.name}
                      </h4>
                      <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
                        <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
                          <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
                            {service.shortDesc}
                          </p>
                          <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
                            <MoveRight
                              color="#ffffff"
                              className="rotate-[-38deg] w-4 h-4"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Mobile: 1-column carousel (<640px) */}
          <div className="sm:hidden w-[90%] mx-auto mt-8 md:mt-12 overflow-hidden">
            <div
              className="flex gap-4 transition-transform duration-400 ease-in-out"
              style={{
                transform: `translateX(calc(-${currentIndex} * 100% - ${currentIndex * 16}px))`,
              }}
            >
              {medicalServices.map((service, idx) => (
                <Link
                  to={`service-detail/${service?.slug}`}
                  key={idx}
                  className="flex-shrink-0 w-full rounded-[12px] overflow-hidden shadow-md group cursor-pointer"
                >
                  <div
                    className="h-[280px] sm:h-[320px] md:h-[364px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.03]"
                    style={{
                      backgroundImage: `
                      linear-gradient(
                        180deg,
                        rgba(102, 102, 102, 0) 40.87%,
                        rgba(23, 23, 23, 0.545192) 69.71%,
                        rgba(14, 14, 14, 0.56) 73.56%,
                        rgba(0, 0, 0, 0.63) 88.94%
                      ),
                      url(${getImageUrl(service.imagePath)})
                    `,
                    }}
                  >
                    <div className="p-3 px-4 w-full">
                      <h4 className="text-[16px] sm:text-[17px] md:text-[20px] font-extrabold">
                        {service.name}
                      </h4>
                      {/* Hover reveal desc */}
                      <div className="max-h-0 overflow-hidden group-hover:max-h-[120px] transition-all duration-400 ease-in-out">
                        <div className="mt-2 pl-3 py-2.5 pr-2.5 rounded-[10px] bg-[#3B3B3B99] flex gap-2 backdrop-blur-[14px]">
                          <p className="text-[12px] sm:text-[13px] text-white font-medium line-clamp-4">
                            {service.shortDesc}
                          </p>
                          <span className="p-2 bg-[#1975FF] rounded-full self-end flex-shrink-0">
                            <MoveRight
                              color="#ffffff"
                              className="rotate-[-38deg] w-4 h-4"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Controls */}
      <div className="w-[90%] mx-auto my-5 flex items-center justify-between">
        <button
          onClick={prev}
          disabled={currentIndex === 0}
          className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 ease-in disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        {/* Dots */}
        <div className="flex gap-2">
          {/* XL Screen: max 4 indicators (for 4 visible items) */}
          {Array.from({ length: maxIndexXL + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`hidden xl:block w-2 h-2 rounded-full transition-all duration-200 ${
                idx === currentIndex
                  ? "bg-[#1975FF] w-5"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
            />
          ))}

          {/* MD to LG Screen: max 3 indicators */}
          {Array.from({ length: maxIndexMD + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`hidden md:block xl:hidden w-2 h-2 rounded-full transition-all duration-200 ${
                idx === currentIndex
                  ? "bg-[#1975FF] w-5"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
            />
          ))}

          {/* SM to MD Screen: max 2 indicators */}
          {Array.from({ length: maxIndexTablet + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`hidden sm:block md:hidden w-2 h-2 rounded-full transition-all duration-200 ${
                idx === currentIndex
                  ? "bg-[#1975FF] w-5"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
            />
          ))}

          {/* Mobile: all indicators */}
          {medicalServices.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`sm:hidden w-2 h-2 rounded-full transition-all duration-200 ${
                idx === currentIndex
                  ? "bg-[#1975FF] w-5"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
            />
          ))}
        </div>

        <button
          onClick={() => {
            // Determine next function based on screen size
            if (windowWidth >= 1280) {
              nextXL();
            } else if (windowWidth >= 768) {
              nextMD();
            } else if (windowWidth >= 640) {
              nextTablet();
            } else {
              nextMobile();
            }
          }}
          disabled={
            windowWidth >= 1280
              ? currentIndex >= maxIndexXL
              : windowWidth >= 768
                ? currentIndex >= maxIndexMD
                : windowWidth >= 640
                  ? currentIndex >= maxIndexTablet
                  : currentIndex >= medicalServices.length - 1
          }
          className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      <Link
        to="/services"
        className="w-fit mx-auto -mt-2 bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
      >
        View Services{" "}
        <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
          <MoveRight color="#000" className="rotate-[-38deg] w-5 h-5" />
        </span>
      </Link>
    </div>
  );
};

export default MedicalServices;